<template>
    <div class="module-time-tracker">
        <template v-if="loading">
            <loading-indicator/>
        </template>
        <template v-else-if="entry">
            <form-row label="Mitarbeiter">
                <div class="time-tracker-reason-box-bold">{{getUsername(entry.employee_id, 'employee')}}</div>
            </form-row>
            <form-row label="Beschreibung">
                <div class="time-tracker-reason-box-bold">{{entry.reason}}</div>
            </form-row>
            <form-row label="Arbeitstag">
                <div class="time-tracker-reason-box-bold">{{dateHelper('d.m.Y', entry.work_day)}}</div>
            </form-row>
            <form-row label="Beantragt">
                <div class="time-tracker-reason-box-bold">{{entry.requested_hours}} Stunden ({{entry.requested_minutes}} Minuten)</div>
            </form-row>
            <form-row label="Status">
                <div v-if="0 === entry.state" class="time-tracker-reason-box-bold"><i class="material-icons" aria-hidden="true" role="img">hourglass_empty</i> Beantragt</div>
                <div v-else-if="1 === entry.state" class="time-tracker-reason-box-bold"><i class="material-icons text-success" aria-hidden="true" role="img">check</i> Antrag angenommen</div>
                <div v-else-if="2 === entry.state" class="time-tracker-reason-box-bold"><i class="material-icons text-danger" aria-hidden="true" role="img">clear</i> Antrag abgelehnt</div>
                <div v-else-if="3 === entry.state" class="time-tracker-reason-box-bold"><i class="material-icons text-warning" aria-hidden="true" role="img">undo</i> Antrag zurückgezogen</div>
                <div v-else-if="4 === entry.state" class="time-tracker-reason-box-bold"><i class="material-icons text-warning" aria-hidden="true" role="img">hourglass_empty</i> Änderung ausstehend</div>
            </form-row>
            <form-row label="Erstellt">
                <div class="time-tracker-reason-box-bold">{{dateHelper('d.m.Y H:i', entry.created)}}</div>
            </form-row>
            <form-row v-if="entry.editor" label="Bearbeitet">
                <div class="time-tracker-reason-box-bold">{{dateHelper('d.m.Y H:i', entry.edited)}} von {{getUsername(entry.editor)}}</div>
            </form-row>
        </template>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import FormRow from '../../../components/form/FormRow.vue';
    import LoadingIndicator from '../../../components/LoadingIndicator.vue';
    import {getUsername} from '../../../filters/username';
    import Loader from '../../../library/intranet/loader';
    import {popupDefaultCancelButton} from '../../../library/popup';
    import TopMessageHandler from '../../../library/topMessageHandler';
    import dateHelper from '../../../utils/portuna/dateHelper';

    @Component({
        name: 'CreditViewPopup',
        components: {
            LoadingIndicator,
            FormRow
        },
        methods: {
            getUsername,
            dateHelper,
        },
        emits: ['update', 'setButtons'],
    })
    export default class CreditViewPopup extends Vue
    {
        @Prop({
            type: Number,
            default: 0,
            required: false,
        }) id: number;

        get buttons()
        {
            let buttons = [];

            buttons.push(popupDefaultCancelButton);

            if(this.allowedEdit && 0 === this.entry?.state)
            {
                buttons.push({
                    type: 'success',
                    title: 'Annehmen',
                    icon: 'check',
                    cmd: () => this.changeStatus(1),
                });

                if(this.entry?.employee_id !== this.currentUser.employeeId)
                {
                    buttons.push({
                        type: 'danger',
                        title: 'Ablehnen',
                        icon: 'clear',
                        cmd: () => this.changeStatus(2),
                    })
                }
            }

            return buttons;
        }

        entry = null as Nullable<OvertimeCreditListEntryView>;

        allowedEdit: boolean = false;

        loading: boolean = false;

        created()
        {
            this.fetch();
        }

        fetch()
        {
            this.axios.get(`/employee/time-tracker/overtime/get-credit-request-template?id=${this.id}`)
            .then(({data: {data: r}}) => {
                this.entry = r.entry;
                this.allowedEdit = r.allowed_edit;
                this.loading = false;
                this.emitter.emit('lazy-load-focus');
                this.emitter.emit('setButtons', this.buttons);
                this.$emit('setButtons', this.buttons);
            })
            .catch(() => {
                TopMessageHandler.error('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.');
                this.emitter.emit('close');
            })
        }

        changeStatus(status: number)
        {
            Loader.show('Bitte warten ...');
            this.axios.post(`/employee/time-tracker/overtime/process-credit-popup/id/${this.id}/state/${status}`)
            .then(({data: {data: r}}) => {
                Loader.hide();
                TopMessageHandler.success(`Sie haben die Stundengutschrift erfolgreich ${1 === status ? 'angenommen' : 'abgelehnt'}.`);
                this.emitter.emit('emit', {event: 'update', data: r.entry});
                this.$emit('update', r.entry);
            })
            .catch(() => {
                Loader.hide();
                TopMessageHandler.error('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.');
                this.emitter.emit('close');
            })
        }
    }
</script>